import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { environment } from '../../environments/environment.prod';
import { Title } from '@angular/platform-browser';


@Injectable({
  providedIn: 'root'
})
export class SubdomainGuard implements CanActivate {

  isMatch: boolean;

  constructor(private router: Router,
    private title: Title) {
  }


  canActivate(): boolean {
    const mapBrand = environment.subdomainBrands;
    this.isPresentUrl(mapBrand);
    if (this.isMatch) {
      return true;
    } else {
      return false;
    }
  }

  isPresentUrl(mapBrand: any) {
    Object.keys(mapBrand).map((key) => {
      if (document.location.host.toLowerCase().includes(mapBrand[key].toLowerCase())) {
        // console.log('************** Match ', key);
        if (key === 'firstCitizens') {
          this.isMatch = false;
          this.haveHeaderFirstcitizens();
        } else if (key === 'myrewards') {
          this.isMatch = false;
          this.haveHeaderMyRewards();
        } else if (key === 'ncb') {
          this.isMatch = false;
          this.haveHeaderNCB();
        } else if (key === 'lifemiles') {
          this.isMatch = false;
          this.haveHeaderLifeMiles();
        } else if (key === 'milescare') {
          this.isMatch = false;
          this.haveHeaderMilesCare();
        } else if (key === 'cibc') {
          this.isMatch = false;
          this.haveHeaderCibc();
        } else if (key === 'lifemilesMoreRate') {
          this.isMatch = false;
          this.haveHeaderLifeMilesMoreRate();
        } else if (key === 'credomatic') {
          this.isMatch = false;
          this.haveHeaderCredomatic();
        } else if (key === 'apap') {
          this.isMatch = false;
          this.haveHeaderApap();
        } else if (key === 'scotia') {
          this.isMatch = false;
          this.haveHeaderScotia();
        } else if (key === 'popular') {
          this.isMatch = false;
          this.haveHeaderPopular();
        } else if (key === 'milesBlue') {
          this.isMatch = false;
          this.haveHeaderMilesBlue();
        } else if (key === 'cryptmi') {
          this.isMatch = false;
          this.haveHeaderCryptmi();
        } else if (key === 'chn') {
          this.isMatch = false;
          this.haveHeaderCHN();
        } else if (key === 'home') {
          this.haveHeaderHome();
        } else if (key === 'cuscatlan') {
          this.haveHeaderMultiPuntosCuscatlan();
        } else if (key === 'imagine') {
          this.haveHeaderImagine();
        } else if (key === 'one') {
          this.haveHeaderOne();
        } else if (key === 'localhost') {
          this.haveHeaderOne();
        }
        this.validateLanguaje(key);
      }
    });
  }

  haveHeaderMultiPuntosCuscatlan() {
    if (document.location.href.toLowerCase().includes('?header=oculto')) {
      this.router.navigateByUrl('MultiPuntos?header=oculto');
    } else {
      this.router.navigateByUrl('MultiPuntos');
    }
  }

  haveHeaderFirstcitizens() {
    if (document.location.href.toLowerCase().includes('?header=oculto')) {
      this.router.navigateByUrl('firstcitizens?header=oculto');
    } else {
      this.router.navigateByUrl('firstcitizens');
    }
  }

  haveHeaderNCB() {
    if (document.location.href.toLowerCase().includes('?header=oculto')) {
      this.router.navigateByUrl('ncb?header=oculto');
    } else {
      this.router.navigateByUrl('ncb');
    }
  }

  haveHeaderMyRewards() {
    if (document.location.href.toLowerCase().includes('?header=oculto')) {
      this.router.navigateByUrl('myrewards?header=oculto');
    } else {
      this.router.navigateByUrl('myrewards');
    }
  }

  haveHeaderCibc() {
    if (document.location.href.toLowerCase().includes('?header=oculto')) {
      this.router.navigateByUrl('cibc?header=oculto');
    } else {
      this.router.navigateByUrl('cibc');
    }
  }

  haveHeaderLifeMiles() {
    if (document.location.href.toLowerCase().includes('?header=oculto')) {
      this.router.navigateByUrl('lifemiles?header=oculto');
    } else {
      this.router.navigateByUrl('lifemiles');
    }
  }

  haveHeaderMilesCare() {
    if (document.location.href.toLowerCase().includes('?header=oculto')) {
      this.router.navigateByUrl('milescare?header=oculto');
    } else {
      this.router.navigateByUrl('milescare');
    }
  }


  haveHeaderLifeMilesMoreRate() {
    if (document.location.href.toLowerCase().includes('?header=oculto')) {
      this.router.navigateByUrl('lifemiles-more-fare?header=oculto');
    } else {
      this.router.navigateByUrl('lifemiles-more-fare');
    }
  }

  haveHeaderCredomatic() {
    if (document.location.href.toLowerCase().includes('?header=oculto')) {
      this.router.navigateByUrl('bac?header=oculto');
    } else {
      this.router.navigateByUrl('bac');
    }
  }

  haveHeaderApap() {
    if (document.location.href.toLowerCase().includes('?header=oculto')) {
      this.router.navigateByUrl('apap?header=oculto');
    } else {
      this.router.navigateByUrl('apap');
    }
  }

  haveHeaderScotia() {
    if (document.location.href.toLowerCase().includes('?header=oculto')) {
      this.router.navigateByUrl('scotia?header=oculto');
    } else {
      this.router.navigateByUrl('scotia');
    }
  }
  haveHeaderPopular() {
    if (document.location.href.toLowerCase().includes('?header=oculto')) {
      this.router.navigateByUrl('popular?header=oculto');
    } else {
      this.router.navigateByUrl('popular');
    }
  }

  haveHeaderMilesBlue() {
    if (document.location.href.toLowerCase().includes('?header=oculto')) {
      this.router.navigateByUrl('miles-blue?header=oculto');
    } else {
      this.router.navigateByUrl('miles-blue');
    }
  }

  haveHeaderCryptmi() {
    if (document.location.href.toLowerCase().includes('?header=oculto')) {
      this.router.navigateByUrl('cryptmi?header=oculto');
    } else {
      this.router.navigateByUrl('cryptmi');
    }
  }

  haveHeaderImagine() {
    if (document.location.href.toLowerCase().includes('?header=oculto')) {
      this.router.navigateByUrl('imagine?header=oculto');
    } else {
      this.router.navigateByUrl('imagine');
    }
  }

  haveHeaderHome() {
    if (document.location.href.toLowerCase().includes('?header=oculto')) {
      this.isMatch = true;
      this.router.navigateByUrl('home?header=oculto');
    } else {
      this.isMatch = true;
    }
  }

  haveHeaderCHN() {
    if (document.location.href.toLowerCase().includes('?header=oculto')) {
      this.router.navigateByUrl('puntos-CHN?header=oculto');
    } else {
      this.router.navigateByUrl('puntos-CHN');
    }
  }

  haveHeaderOne() {
    if (document.location.href.toLowerCase().includes('?header=oculto')) {
      this.router.navigateByUrl('one?header=oculto');
    } else {
      this.router.navigateByUrl('one');
    }
  }

  validateLanguaje(key: string) {
    const defaultlang = environment.configLanguageBrand[key];
    if (defaultlang) {
      sessionStorage.setItem('lang', defaultlang['languageDefault']);
      this.changeTitleForLang(defaultlang['languageDefault']);
    } else {
      let defaultLang = environment.configLanguageBrand.default;
      sessionStorage.setItem('lang', defaultlang);
      this.changeTitleForLang(defaultLang);
    }
  }

  changeTitleForLang(lang: string) {
    if (lang === 'en') {
      this.title.setTitle('Terms and conditions');
    } else if (lang === 'es') {
      this.title.setTitle('Términos y Condiciones');
    }
  }
}
